<template>
  <div style="max-width:100%;overflow:hidden">
  <a
    v-if="linkText && hasTooltip"
    v-tooltip="linkText"
    :target="targetType"
    class="clickable ellipsis"
    :href="link">{{linkText}}</a>
  <a
    v-if="linkText && !hasTooltip"
    class="ellipsis clickable"
    :target="targetType"
    :href="link">{{linkText}}</a>
    
  <span v-if="!linkText">-</span>
</div>
</template>

<script>
  export default {
    name: 'AsLink',
    props: {
      
      props: {
        type: [Array, Object],
        default: function () {
          return {};
        }
      },
      hasTooltip: {
        type: Boolean,
        default: false
      },
      newTab: {
        type: Boolean,
        default: true
      },
      link: [String],
      linkText: [String, Number]
    },
    
    computed: {
      targetType () {
        return this.newTab ? '_blank' : '_self';
      }
    },
    
    data () {
      return {};
    }
  };
</script>
